import { ClientIds } from 'src/clientSetting/settings'
import { theme } from './theme'

export type Theme = typeof theme

export const clientTheme: Record<ClientIds, Theme> = {
  default: theme,
  'pharmacy-support-web': theme,
}
